import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../utils';

export const DataTableContainer = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn('relative flex flex-col w-full overflow-auto', className)}
      {...props}
      ref={ref}
    />
  );
});

DataTableContainer.displayName = 'DataTableContainer';
